var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"border",attrs:{"variant":"light","pill":""}},[_c('font-awesome-icon',{staticClass:"text-warning",attrs:{"icon":"fa-duotone fa-coin"}}),_vm._v(" "+_vm._s(_vm.creatorGallery.price)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }